import _ from "lodash";
import React from "react";
import styles from "./MultipleAttributeOverride.module.scss";
import { formattedDateWithDefault } from "../../../../utils/formattedDate";
import { ExtensionURLs } from "../GoldenRecordExclusion/Utils";
import moment from "moment";

const OverrideSummary = ({ attributeOverrides }) => {
  const overrides = _.cloneDeep(attributeOverrides);

  const NameObject = (name) => {
    const originalData = name.originalFieldDataCopy;
    const newData = name.originalFieldData;

    const nameObj = {
      currentValues: {
        "Mark as": name["Mark as"],
        Status: "Current Values",
        "Family Name": originalData.family ? originalData.family : "-",
        Suffix: originalData.suffix ? originalData.suffix : "-",
        "First Name": originalData.given ? originalData.given.join(", ") : "-",
        Use: originalData.use ? originalData.use : "-",
        Attribute:
          originalData.extension &&
          originalData.extension.find(
            (ext) => ext.url === ExtensionURLs.attrCode,
          )
            ? originalData.extension.find(
                (ext) => ext.url === ExtensionURLs.attrCode,
              ).valueString
            : "-",
        "Source Timestamp":
          originalData.period && originalData.period.start
            ? formattedDateWithDefault(originalData.period.start)
            : "-",
      },
      newValues: {
        "Mark as": "",
        Status: "New Values",
        "Family Name": newData.family ? newData.family : "-",
        Suffix: newData.suffix ? newData.suffix : "-",
        "First Name": newData.given
          ? newData.given.filter((n) => !_.isEmpty(n)).join(", ")
          : "-",
        Use: newData.use ? newData.use : "-",
        Attribute:
          originalData.extension &&
          originalData.extension.find(
            (ext) => ext.url === ExtensionURLs.attrCode,
          )
            ? originalData.extension.find(
                (ext) => ext.url === ExtensionURLs.attrCode,
              ).valueString
            : "-",
        "Source Timestamp":
          newData.period && newData.period.start
            ? formattedDateWithDefault(newData.period.start)
            : "-",
      },
    };
    if (name["Mark as"] === "Inactive") {
      nameObj.newValues.Use = "old";
    }
    if (name["Mark as"] === "Invalid") {
      Object.keys(nameObj.newValues).forEach((key) => {
        if (key !== "Mark as" && key !== "Status") {
          nameObj.newValues[key] = "-";
        }
      });
    }

    return nameObj;
  };

  const AddressObject = (address) => {
    const originalData = address.originalFieldDataCopy;
    const newData = address.originalFieldData;

    const addressObj = {
      currentValues: {
        "Mark as": address["Mark as"],
        Status: "Current Values",
        "Address Line": originalData.line ? originalData.line.join(", ") : "-",
        City: originalData.city ? originalData.city : "-",
        District: originalData.district ? originalData.district : "-",
        State: originalData.state ? originalData.state : "-",
        Country: originalData.country ? originalData.country : "-",
        "Postal Code": originalData.postalCode ? originalData.postalCode : "-",
        Use: originalData.use ? originalData.use : "-",
        Attribute:
          originalData.extension &&
          originalData.extension.find(
            (ext) => ext.url === ExtensionURLs.attrCode,
          )
            ? originalData.extension.find(
                (ext) => ext.url === ExtensionURLs.attrCode,
              ).valueString
            : "-",
        "Source Timestamp":
          originalData.extension &&
          originalData.extension.find(
            (ext) => ext.url === ExtensionURLs.addressSrcTimeStamp,
          )
            ? formattedDateWithDefault(
                originalData.extension.find(
                  (ext) => ext.url === ExtensionURLs.addressSrcTimeStamp,
                ).valueDateTime,
              )
            : "-",
        "Address Start Date":
          originalData.period && originalData.period.start
            ? formattedDateWithDefault(originalData.period.start)
            : "-",
        "Address End Date":
          originalData.period && originalData.period.end
            ? formattedDateWithDefault(originalData.period.end)
            : "-",
      },
      newValues: {
        "Mark as": "",
        Status: "New Values",
        "Address Line": newData.line ? newData.line.join(", ") : "-",
        City: newData.city ? newData.city : "-",
        District: newData.district ? newData.district : "-",
        State: newData.state ? newData.state : "-",
        Country: newData.country ? newData.country : "-",
        "Postal Code": newData.postalCode ? newData.postalCode : "-",
        Use: newData.use ? newData.use : "-",
        Attribute:
          newData.extension &&
          newData.extension.find((ext) => ext.url === ExtensionURLs.attrCode)
            ? newData.extension.find(
                (ext) => ext.url === ExtensionURLs.attrCode,
              ).valueString
            : "-",
        "Source Timestamp":
          newData.extension &&
          newData.extension.find(
            (ext) => ext.url === ExtensionURLs.addressSrcTimeStamp,
          )
            ? formattedDateWithDefault(
                newData.extension.find(
                  (ext) => ext.url === ExtensionURLs.addressSrcTimeStamp,
                ).valueDateTime,
              )
            : "-",
        "Address Start Date":
          newData.period && newData.period.start
            ? formattedDateWithDefault(newData.period.start)
            : "-",
        "Address End Date":
          newData.period && newData.period.end
            ? formattedDateWithDefault(newData.period.end)
            : "-",
      },
    };
    if (address["Mark as"] === "Inactive") {
      addressObj.newValues.Use = "old";
    }
    if (address["Mark as"] === "Invalid") {
      Object.keys(addressObj.newValues).forEach((key) => {
        if (key !== "Mark as" && key !== "Status") {
          addressObj.newValues[key] = "-";
        }
      });
    }

    return addressObj;
  };

  const IdentifierObject = (identifier) => {
    const originalData = identifier.originalFieldDataCopy;
    const newData = identifier.originalFieldData;

    const identifierObj = {
      currentValues: {
        "Mark as": identifier["Mark as"],
        Status: "Current Values",
        System: originalData.system
          ? originalData.system
          : originalData.type &&
              originalData.type.coding &&
              originalData.type.coding[0] &&
              originalData.type.coding[0].code
            ? originalData.type.coding[0].code
            : "-",
        Value: originalData.value ? originalData.value : "-",
        Use: originalData.use ? originalData.use : "-",
        "Source Timestamp":
          originalData.period && originalData.period.start
            ? formattedDateWithDefault(originalData.period.start)
            : "-",
      },
      newValues: {
        "Mark as": "",
        Status: "New Values",
        System: newData.system
          ? newData.system
          : newData.type &&
              newData.type.coding &&
              newData.type.coding[0] &&
              newData.type.coding[0].code
            ? newData.type.coding[0].code
            : "-",
        Value: newData.value ? newData.value : "-",
        Use: newData.use ? newData.use : "-",
        "Source Timestamp":
          newData.period && newData.period.start
            ? formattedDateWithDefault(newData.period.start)
            : "-",
      },
    };
    if (identifier["Mark as"] === "Inactive") {
      identifierObj.newValues.Use = "old";
    }
    if (identifier["Mark as"] === "Invalid") {
      Object.keys(identifierObj.newValues).forEach((key) => {
        if (key !== "Mark as" && key !== "Status") {
          identifierObj.newValues[key] = "-";
        }
      });
    }

    return identifierObj;
  };

  const CoverageIMDMObject = (coverageIMDM) => {
    const originalData = coverageIMDM.originalFieldDataCopy;
    const newData = coverageIMDM.originalFieldData;
    const originalCoverageValue = JSON.parse(originalData.value);
    const newCoverageValue = JSON.parse(newData.value);

    const coverageIMDMObj = {
      currentValues: {
        "Mark as": coverageIMDM["Mark as"],
        Status: "Current Values",
        "Policy Number": originalCoverageValue.policyNum
          ? originalCoverageValue.policyNum
          : "-",
        "Dependent Code": originalCoverageValue.dependentCd
          ? originalCoverageValue.dependentCd
          : "-",
        "Division Code": originalCoverageValue.divisionCd
          ? originalCoverageValue.divisionCd
          : "-",
        "Relationship Code": originalCoverageValue.relationshipCd
          ? originalCoverageValue.relationshipCd
          : "-",
        "Family Id": originalCoverageValue.familyID
          ? originalCoverageValue.familyID
          : "-",
        "Member Id": originalCoverageValue.memberID
          ? originalCoverageValue.memberID
          : "-",
        "Subscriber Id": originalCoverageValue.subscriberID
          ? originalCoverageValue.subscriberID
          : "-",
        "Carrier Id": originalCoverageValue.carrierID
          ? originalCoverageValue.carrierID
          : "-",
        "Account Id": originalCoverageValue.accountID
          ? originalCoverageValue.accountID
          : "-",
        "Group Id": originalCoverageValue.groupID
          ? originalCoverageValue.groupID
          : "-",
        "Original System Id": originalCoverageValue.origSysId
          ? originalCoverageValue.origSysId
          : "-",
        "Medicaid RN": originalCoverageValue.medicaidRN
          ? originalCoverageValue.medicaidRN
          : "-",
        Use: originalData.use ? originalData.use : "-",
        "Source Timestamp":
          originalData.period && originalData.period.start
            ? formattedDateWithDefault(originalData.period.start)
            : "-",
      },
      newValues: {
        "Mark as": "",
        Status: "New Values",
        "Policy Number": newCoverageValue.policyNum
          ? newCoverageValue.policyNum
          : "-",
        "Dependent Code": newCoverageValue.dependentCd
          ? newCoverageValue.dependentCd
          : "-",
        "Division Code": newCoverageValue.divisionCd
          ? newCoverageValue.divisionCd
          : "-",
        "Relationship Code": newCoverageValue.relationshipCd
          ? newCoverageValue.relationshipCd
          : "-",
        "Family Id": newCoverageValue.familyID
          ? newCoverageValue.familyID
          : "-",
        "Member Id": newCoverageValue.memberID
          ? newCoverageValue.memberID
          : "-",
        "Subscriber Id": newCoverageValue.subscriberID
          ? newCoverageValue.subscriberID
          : "-",
        "Carrier Id": newCoverageValue.carrierID
          ? newCoverageValue.carrierID
          : "-",
        "Account Id": newCoverageValue.accountID
          ? newCoverageValue.accountID
          : "-",
        "Group Id": newCoverageValue.groupID ? newCoverageValue.groupID : "-",
        "Original System Id": newCoverageValue.origSysId
          ? newCoverageValue.origSysId
          : "-",
        "Medicaid RN": newCoverageValue.medicaidRN
          ? newCoverageValue.medicaidRN
          : "-",
        Use: newData.use ? newData.use : "-",
        "Source Timestamp":
          newData.period && newData.period.start
            ? formattedDateWithDefault(newData.period.start)
            : "-",
      },
    };

    if (coverageIMDM["Mark as"] === "Inactive") {
      coverageIMDMObj.newValues.Use = "old";
    }

    if (coverageIMDM["Mark as"] === "Invalid") {
      Object.keys(coverageIMDMObj.newValues).forEach((key) => {
        if (key !== "Mark as" && key !== "Status") {
          coverageIMDMObj.newValues[key] = "-";
        }
      });
    }

    return coverageIMDMObj;
  };

  const TelecomObject = (telecom) => {
    const originalData = telecom.originalFieldDataCopy;
    const newData = telecom.originalFieldData;

    const telecomObj = {
      currentValues: {
        "Mark as": telecom["Mark as"],
        Status: "Current Values",
        System: originalData.system ? originalData.system : "-",
        Value: originalData.value ? originalData.value : "-",
        Use: originalData.use ? originalData.use : "-",
        Attribute:
          originalData.extension &&
          originalData.extension.find(
            (ext) => ext.url === ExtensionURLs.attrCode,
          )
            ? originalData.extension.find(
                (ext) => ext.url === ExtensionURLs.attrCode,
              ).valueString
            : "-",
        "Source Timestamp":
          originalData.period && originalData.period.start
            ? formattedDateWithDefault(originalData.period.start)
            : "-",
      },
      newValues: {
        "Mark as": "",
        Status: "New Values",
        System: newData.system ? newData.system : "-",
        Value: newData.value ? newData.value : "-",
        Use: newData.use ? newData.use : "-",
        Attribute:
          newData.extension &&
          newData.extension.find((ext) => ext.url === ExtensionURLs.attrCode)
            ? newData.extension.find(
                (ext) => ext.url === ExtensionURLs.attrCode,
              ).valueString
            : "-",
        "Source Timestamp":
          newData.period && newData.period.start
            ? formattedDateWithDefault(newData.period.start)
            : "-",
      },
    };

    if (telecom["Mark as"] === "Inactive") {
      telecomObj.newValues.Use = "old";
    }

    if (telecom["Mark as"] === "Invalid") {
      Object.keys(telecomObj.newValues).forEach((key) => {
        if (key !== "Mark as" && key !== "Status") {
          telecomObj.newValues[key] = "-";
        }
      });
    }

    return telecomObj;
  };

  const GenderObject = (gender) => {
    const genderObj = {
      currentValues: {
        "Mark as": gender["Mark as"],
        Status: "Current Value",
        Gender: gender.originalFieldDataCopy
          ? gender.originalFieldDataCopy
          : "-",
      },
      newValues: {
        "Mark as": "",
        Status: "New Value",
        Gender: gender.originalFieldData ? gender.originalFieldData : "-",
      },
    };

    return genderObj;
  };

  const BirthDateObject = (birthDate) => {
    const birthDateObj = {
      currentValues: {
        "Mark as": birthDate["Mark as"],
        Status: "Current Value",
        "Birth Date": birthDate.originalFieldDataCopy
          ? moment(birthDate.originalFieldDataCopy).format("L")
          : "-",
      },
      newValues: {
        "Mark as": "",
        Status: "New Value",
        "Birth Date": birthDate.originalFieldData
          ? moment(birthDate.originalFieldData).format("L")
          : "-",
      },
    };

    return birthDateObj;
  };

  const MultipleBirthObject = (multipleBirth) => {
    const multipleBirthObj = {
      currentValues: {
        "Mark as": multipleBirth["Mark as"],
        Status: "Current Value",
        "Multiple Birth": multipleBirth.originalFieldDataCopy
          ? "true"
          : "false",
      },
      newValues: {
        "Mark as": "",
        Status: "New Value",
        "Multiple Birth": multipleBirth.originalFieldData ? "true" : "false",
      },
    };

    return multipleBirthObj;
  };

  const SummaryTable = ({ detailMap }) => {
    return (
      <table>
        <thead>
          <tr>
            {Object.keys(detailMap.currentValues).map((key) => (
              <th>{key}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {Object.values(detailMap.currentValues).map((value) => (
              <td>{value}</td>
            ))}
          </tr>
          <tr>
            {Object.values(detailMap.newValues).map((value) => (
              <td>{value}</td>
            ))}
          </tr>
        </tbody>
      </table>
    );
  };

  const names = overrides.name.map((n) => NameObject(n));
  const addresses = overrides.address.map((a) => AddressObject(a));
  const identifiers = overrides.identifier.map((i) => IdentifierObject(i));
  const coverageIMDM = overrides.coverageIMDM.map((c) => CoverageIMDMObject(c));
  const telecoms = overrides.telecom.map((t) => TelecomObject(t));
  const genders = overrides.gender.map((g) => GenderObject(g));
  const birthDates = overrides.birthDate.map((b) => BirthDateObject(b));
  const multipleBirths = overrides.multipleBirth.map((m) =>
    MultipleBirthObject(m),
  );

  return (
    <div className={styles.summaryTable}>
      {!_.isEmpty(names) && (
        <div>
          <h2>Name</h2>
          {names.map((detailMap) => (
            <SummaryTable detailMap={detailMap} />
          ))}
        </div>
      )}
      {!_.isEmpty(addresses) && (
        <div>
          <h2>Address</h2>
          {addresses.map((detailMap) => (
            <SummaryTable detailMap={detailMap} />
          ))}
        </div>
      )}
      {!_.isEmpty(genders) && (
        <div>
          <h2>Gender</h2>
          {genders.map((detailMap) => (
            <SummaryTable detailMap={detailMap} />
          ))}
        </div>
      )}
      {!_.isEmpty(birthDates) && (
        <div>
          <h2>Date of Birth</h2>
          {birthDates.map((detailMap) => (
            <SummaryTable detailMap={detailMap} />
          ))}
        </div>
      )}
      {!_.isEmpty(multipleBirths) && (
        <div>
          <h2>Multiple Birth</h2>
          {multipleBirths.map((detailMap) => (
            <SummaryTable detailMap={detailMap} />
          ))}
        </div>
      )}
      {!_.isEmpty(telecoms) && (
        <div>
          <h2>Contact Information</h2>
          {telecoms.map((detailMap) => (
            <SummaryTable detailMap={detailMap} />
          ))}
        </div>
      )}
      {!_.isEmpty(overrides.identifier) && (
        <div>
          <h2>Identifier</h2>
          {identifiers.map((detailMap) => (
            <SummaryTable detailMap={detailMap} />
          ))}
        </div>
      )}
      {!_.isEmpty(coverageIMDM) && (
        <div>
          <h2>Coverage</h2>
          {coverageIMDM.map((detailMap) => (
            <SummaryTable detailMap={detailMap} />
          ))}
        </div>
      )}
    </div>
  );
};

export default OverrideSummary;
